import type { InternalAppType } from "types/branding";
import { AUDIENCE_APP_URLS } from "config/audience";

export function getAudienceBaseUrl(environment: "dev" | "prod", internalAppType: InternalAppType): string {
  return AUDIENCE_APP_URLS[environment][internalAppType];
}

/** Branding is presentation only; the package parameter grants no map access. */
export function getAudienceUrl(appUrl: string, mapId: string, brandingPackageId?: string): string {
  const url = new URL(appUrl);
  const parameters = new URLSearchParams({ page: "map-page", map: mapId });
  if (brandingPackageId?.trim()) parameters.set("bpid", brandingPackageId.trim());
  url.search = "audience&" + parameters.toString();
  return url.toString();
}
